import React from 'react'
import GalleryPage from './Gallery'


export default function index() {
   
 
    return (
        <GalleryPage/>
    )

}
